'use client'

import ClientOverlays from '@/core/components/client-overlays'
import ThemeProvider from '@/core/components/theme/theme-provider'

import type { ReactNode } from 'react'

type AppProvidersProps = {
  children: ReactNode
}

export default function AppProviders({ children }: AppProvidersProps) {
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="dark"
      enableSystem={false}
      disableTransitionOnChange
    >
      {children}
      <ClientOverlays />
    </ThemeProvider>
  )
}
